export default class EmployeeDTO {
    id: string;

    name: string;

    username: string;

    email: string;

    constructor(obj: any) {
      this.id = obj.id || '';
      this.name = obj.name || '';
      this.username = obj.username || '';
      this.email = obj.email
    }

    public static of(obj: any): EmployeeDTO {
      return new EmployeeDTO(obj || {});
    }

    public static ofList(obj: any[]): EmployeeDTO[] {
      return obj.map(this.of);
    }
}
